export enum NumerationSchemeType {
    SEQUENTIAL_NUMBER = 'SEQUENTIAL_NUMBER',
    CURRENT_MONTH = 'CURRENT_MONTH',
    CURRENT_YEAR = 'CURRENT_YEAR',
    CURRENT_YEAR_SMALL = 'CURRENT_YEAR_SMALL',
    WORK_TYPE = 'WORK_TYPE',
    USER_INITIALS = 'USER_INITIALS',
    TEXT = 'TEXT'
}
